import React from "react";
import { Text, View } from "@react-pdf/renderer";

const ExhaustAirAccessoires = () => {
  return (
    <View
      wrap={false}
      style={{
        border: "2px solid black",
        fontSize: "8px",
        marginTop: "10px",
        paddingHorizontal: "5px",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
      }}
    >
      <View style={{ width: "98%", borderRight: "1px solid black" }}>
        <Text style={{ fontSize: "10px" }}>Zubehör Abluft</Text>
        <View style={{ display: "flex", flexDirection: "row" }}>
          <Text style={{ marginRight: "5px" }}>1</Text>
          <Text>Revisionstüren</Text>
        </View>
        <View style={{ display: "flex", flexDirection: "row" }}>
          <Text style={{ marginRight: "5px" }}>1</Text>
          <Text>Luftklappen Aul / Bypass</Text>
        </View>
        <View style={{ display: "flex", flexDirection: "row" }}>
          <Text style={{ marginRight: "5px" }}>1</Text>
          <Text>Flex. Manschette nicht isoliert</Text>
        </View>
        <View style={{ display: "flex", flexDirection: "row" }}>
          <Text style={{ marginRight: "5px" }}>1</Text>
          <Text>Flex. Manschette isoliert</Text>
        </View>
        <View style={{ display: "flex", flexDirection: "row" }}>
          <Text style={{ marginRight: "5px" }}>1</Text>
          <Text>Potentialausgleich zu Flex. M</Text>
        </View>
        <View style={{ display: "flex", flexDirection: "row" }}>
          <Text style={{ marginRight: "5px" }}>2</Text>
          <Text>Anschlussrahmen</Text>
        </View>
        <View style={{ display: "flex", flexDirection: "row" }}>
          <Text style={{ marginRight: "5px" }}>1</Text>
          <Text>Filterüberwachung</Text>
        </View>
        <View style={{ display: "flex", flexDirection: "row" }}>
          <Text style={{ marginRight: "5px" }}>2</Text>
          <Text>Beleuchtungen</Text>
        </View>
        <View style={{ display: "flex", flexDirection: "row" }}>
          <Text style={{ marginRight: "5px" }}>1</Text>
          <Text>Schauglas</Text>
        </View>
      </View>
      <View
        style={{
          width: "2%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          paddingLeft: "2px",
        }}
      >
        <Text>3</Text>
      </View>
    </View>
  );
};

export default ExhaustAirAccessoires;
